import { render, staticRenderFns } from "./ItemDropdown.vue?vue&type=template&id=085d232e&scoped=true&"
import script from "./ItemDropdown.vue?vue&type=script&lang=js&"
export * from "./ItemDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ItemDropdown.vue?vue&type=style&index=0&id=085d232e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d232e",
  null
  
)

export default component.exports